import { createSiteAllowlistFlagFromVar } from "@/utils/siteAllowlistFlag";

/** Saved-block types and the Blocks library page, by site allowlist. */
export const isSavedBlockTypesEnabledForSite = createSiteAllowlistFlagFromVar(
  import.meta.env.VITE_FF_SAVED_BLOCK_TYPES_SITES,
);
